


































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { siteConfig } from '@/SiteConfig.ts';

@Component
export default class PrivacyPolicyComponent extends Vue {
  private titleClasses = ['text-left', 'py-3'];
}
